<template>
    <div class="preview-content">
        <div class="preview-detail">
            <div class="preview-title">
                <el-button class="title-btn" style="width: 68px; height: 32px;" round
                    @click="$router.go(-1)">返回</el-button>
                <span>公告详情</span>
                <div class="preview-date"></div>
            </div>
            <div class="line"></div>

            <div v-if="!offShelf" class="preDetail">
                <div class="content-wrapper">
                    <div class="preview-meta">
                        <div class="meta-item" v-if="form.title">
                            <span class="meta-value1">{{ form.title }}</span>
                        </div>
                        <div class="meta-item" v-if="form.categoryName || form.author">
                            <span class="meta-value">{{ (form.author || '')
                            }}</span>
                            <span style="padding: 0 10px;">|</span>
                            <span class="meta-value" style="color: #409EFF;">
                                {{ '#' + (form.categoryName || '') + '#' }}
                            </span>
                        </div>
                        <div class="meta-item">
                            <span class="meta-value">{{ form.publishTime }}</span>
                        </div>
                    </div>

                    <div class="preview-body">
                        <!-- 这里将显示公告内容 -->
                        <div class="preview-html" v-html="form.content"></div>
                    </div>
                </div>

                <!-- 附件区域 - 移到内容区域下方 -->
                <div class="preview-attachments" v-if="form.attachmentList && form.attachmentList.length">
                    <h3>附件</h3>
                    <approval-attachment-list :files="form.attachmentList"/>
                </div>

                <div class="preview-read">
                    <span>共{{ form.readCount || 0 }}人已读</span>
                    <span style="padding:0 10px;">|</span>
                    <span v-if="form.readStatus === '3'">
                        <template v-for="(item, index) in form.confirmList">
                            {{ item }}{{ index < form.confirmList.length - 1 ? '、' : '' }} </template>
                                等{{ form.confirmCount }}人已确认
                    </span>
                </div>
            </div>
            <div v-else class="preDetail-offShelf">
                <img src="@/assets/img/announcement/img_wugonggao.png" alt=""
                    style="display: block; margin: 160px auto 0;">
                <div>公告已撤回 / 公告已下架</div>
                <el-button class="btn-footer1" type="success" plain size="small" @click="$router.go(-1)">返回</el-button>
            </div>
        </div>

        <div v-if="!offShelf" class="preview-btns">
            <el-button class="btn-footer" type="info" plain size="small" @click="$router.go(-1)">返回</el-button>
            <el-button class="btn-footer" type="primary" size="small" @click="getConfirm"
                :disabled="form.readStatus === '3'" :loading="confirmLoading">
                {{ form.readStatus === '3' ? '已确认' : '确认' }}
            </el-button>
        </div>
    </div>
</template>

<script>
import ApprovalAttachmentList from '@/components/ApprovalAttachmentList.vue'
export default {
    name: 'Preview',
    components:{ApprovalAttachmentList},
    data() {
        // 提取初始表单结构用于重置
        const initialFormState = {
            title: '',
            categoryName: '',
            author: '',
            content: '',
            receivers: [],
            readCount: 0,
            confirmList: [],
            attachmentList: [],
            readStatus: '',
            confirmCount: 0,
            publishTime: '',
        };
        return {
            currentTime: new Date().toLocaleString(),
            offShelf: false, // 上下架状态 true为下架 false为正常
            form: {
                title: '',
                categoryName: '', // 添加categoryName字段
                author: '',
                content: '', // 确保有content字段
                receivers: [],
                readCount: 0,
                confirmList: [], // 确认列表
                attachmentList: [], // 修改字段名与模板一致
                readStatus: '', // 1未读 2已读 3已确认
                confirmCount: 0, // 确认数
                publishTime: '', // 发布时间
            },
            confirm: false, // 确认状态
            confirmLoading: false, // 确认按钮加载状态
            initialFormState //保存初始状态用于重置
        }
    },
    watch: {
        // // 监听路由变化，当 id 参数变化时重新获取数据
        // '$route.query.id': {
        //     immediate: true,
        //     handler(newId, oldId) {
        //         // 只有当id真正发生变化且不为空，且当前路由是公告详情页时才调用接口
        //         if (newId && newId !== oldId && this.$route.name === 'announcementLookDetail') {
        //             this.fetchAnnouncementDetail();
        //         }
        //     }
        // },
        // // 监听路由名称变化，确保在正确的路由下才处理
        // '$route.name': {
        //     handler(newName) {
        //         // 如果路由名称不是公告详情页，清空表单数据
        //         if (newName !== 'announcementLookDetail') {
        //             this.form = {
        //                 title: '',
        //                 categoryName: '',
        //                 author: '',
        //                 content: '',
        //                 receivers: [],
        //                 readCount: 0,
        //                 confirmList: [],
        //                 attachmentList: [],
        //                 readStatus: '',
        //                 publishTime: '',
        //             };
        //         }
        //     }
        // }
        // 监听路由参数变化
        '$route': {
            immediate: true,
            handler(to, from) {
                // 只有当路由名正确且id存在时才获取数据
                if (to.name === 'announcementLookDetail' && to.query.id) {
                    this.resetData();
                    this.fetchAnnouncementDetail();
                }
            }
        }
    },
    // // 处理组件复用情况
    // activated() {
    //     if (this.$route.name === 'announcementLookDetail' && this.$route.query.id) {
    //         this.resetData();
    //         this.fetchAnnouncementDetail();
    //     }
    // },
    methods: {
        // 重置数据到初始状态
        resetData() {
            this.offShelf = false;
            this.form = {...this.initialFormState};
            this.confirm = false;
            this.confirmLoading = false;
        },
        formatFileSize(size) {
            if (size < 1024) {
                return size + 'B';
            } else if (size < 1024 * 1024) {
                return (size / 1024).toFixed(2) + 'KB';
            } else if (size < 1024 * 1024 * 1024) {
                return (size / (1024 * 1024)).toFixed(2) + 'MB';
            } else {
                return (size / (1024 * 1024 * 1024)).toFixed(2) + 'GB';
            }
        },
        // 获取公告详情
        fetchAnnouncementDetail() {
            this.$api.announcementLookDetail({ id: this.$route.query.id }).then(res => {
                if (res.code == 0) {
                    const detail = res.data;
                    
                    // 正确回显数据到表单
                    this.form.title = detail.title || '';
                    this.form.categoryName = detail.categoryName || '';
                    this.form.author = detail.author || '';
                    this.form.publishTime = detail.publishTime || '';
                    this.form.confirmList = detail.confirmList || [];
                    this.form.readCount = detail.readCount || 0;
                    this.form.content = detail.content || '';
                    this.form.readStatus = detail.readStatus || '';
                    this.form.confirmCount = detail.confirmCount || 0;

                    // 回显接收人员
                    if (detail.receiveList && Array.isArray(detail.receiveList)) {
                        this.form.receivers = detail.receiveList;
                    }

                    // 回显附件
                    if (detail.attachmentList && Array.isArray(detail.attachmentList)) {
                        this.form.attachmentList = detail.attachmentList;
                    }

                } else if (res.code == 11001) {
                    this.$message.error('公告已下架');
                    this.offShelf = true;
                } else {
                    this.$message.error('获取公告详情失败');
                }
            }).catch(err => {
                console.error('获取公告详情出错:', err);
                this.$message.error('获取公告详情出错');
            });
        },
        // 确认公告
        getConfirm() {
            this.confirmLoading = true;

            this.$api.announcementLookConfirm({ id: this.$route.query.id }).then(res => {
                this.confirmLoading = false;

                if (res.code == 0) {
                    this.$message.success('确认成功');
                    this.confirm = true;

                    // 刷新页面数据
                    this.fetchAnnouncementDetail();
                } else {
                    this.$message.error(res.message || '确认失败');
                }
            }).catch(err => {
                this.confirmLoading = false;
                console.error('确认公告出错:', err);
                this.$message.error('确认失败');
            });
        },
        // 下载文件
        async downloadFile(file) {
            if (!file.url) {
                this.$message.warning('文件链接不可用');
                return;
            }

            try {

                // 使用fetch获取文件
                const response = await fetch(file.url, {
                    method: 'GET',
                    headers: {
                        // 如果需要身份验证，可以在这里添加token
                        // 'Authorization': 'Bearer ' + your_token
                    }
                });

                if (!response.ok) {
                    throw new Error('网络响应不正常');
                }

                // 将文件数据转换为Blob
                const blob = await response.blob();

                // 创建对象URL
                const blobUrl = URL.createObjectURL(blob);

                // 创建隐藏的下载链接
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = file.name;
                link.style.display = 'none';

                // 添加到DOM并模拟点击
                document.body.appendChild(link);
                link.click();

                // 清理资源
                document.body.removeChild(link);
                URL.revokeObjectURL(blobUrl);

                // this.$message.success(`下载成功: ${file.name}`);
            } catch (error) {
                console.error('下载失败:', error);

                // 如果fetch失败，回退到原始方法（直接打开链接）
                // 对于跨域或CORS问题，这可能无法正常工作
                const link = document.createElement('a');
                link.href = file.url;
                link.target = '_blank'; // 在新标签页打开
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                this.$message.warning('直接下载失败，已在浏览器中打开文件');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.preview-content {
    // min-height: 100vh;
    display: flex;
    flex-direction: column;
    margin: 0 auto;

    .line {
        border-bottom: 1px solid #eee;
        margin-left: -24px;
        width: calc(100% + 48px);
    }

    .preview-detail {
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        padding: 0 25px 20px;
        // margin-bottom: 17px;
        // margin-top: 16px;
        // flex: 1;
        position: relative;
        // min-height: 500px;
        min-height: calc(100vh - 150px);
        /* 确保容器有最小高度 */
    }

    .preview-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        font-weight: 400;
        font-size: 16px;
        color: #1E1E1E;
        margin-top: 21px;

        .title-btn {
            font-weight: 400;
            font-size: 14px;
            color: #1E1E1E;
            display: flex;
            align-items: center;
            padding: 6px 20px;
        }

        .preview-date {
            width: 100px;
        }
    }

    .preDetail {
        width: 100%;
        max-width: 750px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        min-height: 100%;
        padding: 20px 0;
    }

    .content-wrapper {
        flex: 1;
    }

    .preview-meta {
        margin-top: 32px;
        margin-bottom: 20px;
        padding-bottom: 15px;

        .meta-item {
            display: flex;
            margin-bottom: 8px;
            line-height: 21px;

            .meta-label {
                width: 80px;
                color: #666;
                font-weight: bold;
            }

            .meta-value {

                font-weight: 400;
                font-size: 12px;
                color: #7F7F7F;
            }

            .meta-value1 {
                flex: 1;
                font-weight: bold;
                font-size: 24px;
                color: #1E1E1E;
                padding-bottom: 8px;
            }
        }
    }

    .preview-body {
        margin-bottom: 20px;

        ::v-deep .preview-html {
            line-height: 1.6;

            p {
                margin-bottom: 1em;
            }

            img {
                max-width: 100%;
                height: auto;
            }

            table {
                width: 100%;
                border-collapse: collapse;

                th,
                td {
                    border: 1px solid #ddd;
                    padding: 8px;
                }

                th {
                    background-color: #f5f5f5;
                }
            }
        }
    }

    /* 附件区域样式 */
    .preview-attachments {
        margin-top: auto;
        /* 将附件区域推到内容底部 */
        padding: 15px 0;
        border-top: 1px solid #eee;

        h3 {
            margin-bottom: 12px;
            color: #333;
            font-size: 16px;
        }

        .attachment-list {
            display: flex;
            flex-wrap: wrap;
            gap: 15px;
            /* 附件项之间的间距 */
            list-style: none;
            padding: 0;
            margin: 0;

            .attachment-item {
                display: flex;
                align-items: center;
                width: 245px;
                /* 固定宽度 */
                padding: 10px;
                background-color: #f9f9f9;
                border-radius: 4px;
                border: 1px solid #eee;
                cursor: pointer;
                transition: background-color 0.2s;

                &:hover {
                    background-color: #f0f0f0;
                }

                .el-icon-document {
                    width: 32px;
                    height: 32px;
                    margin-right: 8px;
                    flex-shrink: 0;

                    img {
                        width: 32px;
                        height: 32px;
                    }
                }

                .file-info {
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                    min-width: 0;
                    /* 确保文本省略生效 */
                }

                .file-name {
                    color: #333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    /* 限制显示两行 */
                    -webkit-box-orient: vertical;
                    line-height: 1.4;
                    margin-bottom: 4px;
                }

                .file-size {
                    color: #999;
                    font-size: 12px;
                    flex-shrink: 0;
                }
            }
        }
    }

    .preview-read {
        margin-top: 0;
        /* 移除自动边距 */
        padding: 15px 0 30px;
        border-top: 1px solid #eee;
        color: #7F7F7F;
        font-size: 14px;

    }

    .preview-btns {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 20px 0;
        background-color: #fff;
        text-align: center;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
        z-index: 100;

        .btn-footer {
            margin: 0 8px;
            min-width: 100px;
        }
    }

    .preDetail-offShelf {
        text-align: center;
        font-weight: 400;
        font-size: 14px;
        color: #2F3030;

        .btn-footer1 {
            width: 88px;
            margin-top: 20px;
            color: #00B498;
            background-color: #FFFFFF;
            border-color: #00B498;
        }
    }
}
</style>